"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const systemMessage_1 = __importDefault(require("./systemMessage"));
const partnerMessage_1 = __importDefault(require("./partnerMessage"));
const userMessage_1 = __importDefault(require("./userMessage"));
const configureStore_1 = require("../../store/configureStore");
const ChatMessage = (props) => {
    const { messages, userId } = props;
    const { handleIsModal, handleModalContents } = (0, react_1.useContext)(configureStore_1.StoreContext);
    const openImageModal = (src) => {
        handleModalContents(react_1.default.createElement("img", { src: src, style: {
                maxWidth: "100%",
                maxHeight: "100%"
            } }));
        handleIsModal(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, messages.map((current, idx) => {
        return (react_1.default.createElement("article", { key: idx, style: {
                display: "flex",
                flexFlow: "column",
            } },
            current.idx === '#system' &&
                react_1.default.createElement(systemMessage_1.default, { message: current.message }),
            current.idx !== '#system' && current.idx !== userId &&
                react_1.default.createElement(partnerMessage_1.default, { idx: current.idx, message: current.message, openImageModal: openImageModal, time: current.time }),
            current.idx !== '#system' && current.idx === userId &&
                react_1.default.createElement(userMessage_1.default, { message: current.message, openImageModal: openImageModal, time: current.time })));
    })));
};
exports.default = ChatMessage;
